<template>
  <div class="column">
    <div class="button-body">
      <div class="buttons">
        <a class="button" @click="goToExternalLink(url)">
          {{ title }}
          <span style="float: right">></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MFITTExternalLinkButton",
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.ticket-romancecar .column .button-body .buttons .button {
  display: block;
  width: auto;
  background-color: #ffffff;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: normal;
  color: #000000;
  text-decoration: none;
  border: 1px solid #e0e0e0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
</style>
